import type { UserType } from 'contexts/user.context';
import { UserTypeContext } from 'contexts/user.context';
import { useContext } from 'react';

export function useUserType() {
  return useContext<UserType>(UserTypeContext);
}
